import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Button } from '@xingternal/button';
import { useConfig } from '@xingternal/hops';

import { InnerContainer, Container, Hero } from './CtaSection.style';

const CtaSection = () => {
  const { externalUrl } = useConfig();

  return (
    <Container>
      <InnerContainer>
        <Hero size="small" sizeConfined="medium" forwardedAs="h2">
          <FormattedMessage id="WELCOME_STARTPAGE_MAIN_CTA_TEXT" />
        </Hero>
        <Button
          variant="overlay"
          href={`${externalUrl}/start/signup?sc_o=losp_sign_up_button_click&sc_o_PropActionOrigin=losp_sign_up_button_click_cta_3`}
        >
          <FormattedMessage id="WELCOME_STARTPAGE_MAIN_CTA_BUTTON" />
        </Button>
      </InnerContainer>
    </Container>
  );
};

export default CtaSection;
